export default "__VITE_ASSET__gA4qPQWy__"